/* eslint-disable eqeqeq */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Label, Collapse,
} from 'reactstrap';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import {
  Formik, Field, Form, ErrorMessage, FieldArray,
} from 'formik';
import * as Yup from 'yup';
import classnames from 'classnames';
import { post } from '../../helpers/api_helper';
import SupplierPicker from './SupplierPicker';

function TruckForm(props) {
  const { actionUrl, entity, t } = props;

  const [loading, setLoading] = useState(false);
  const [col, setCol] = useState(false);

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const save = async (values) => {
    try {
      if (loading) return;

      setLoading(true);
      const result = await post('/api/sourcing/trucks', values);

      toastr.success(t(`Truck ID ${result.id} saved`), t('Success'));
      props.onSuccess(result);
    } catch (error) {
      toastr.error(t('Error saving truck'), t('Error'));
    } finally {
      setLoading(false);
    }
  };

  const ValidationSchema = Yup.object().shape({
    reference: Yup.string().required(t('Required')),
    cost: Yup.number().nullable(),
    labor_cost: Yup.number().nullable(),
    shipping_cost: Yup.number().nullable(),
    expected_at: Yup.date().nullable(),
    origin: Yup.string().nullable(),
    pallet_count: Yup.number().nullable(),
    unit_count: Yup.number().nullable(),
    supplier_id: Yup.number().nullable(),
    supplier_program: Yup.string().nullable(),
    comments: Yup.string(),
    staged_lanes: Yup.string().nullable(),
  });

  const tcol = () => {
    setCol(!col);
  };

  const jsx = (
    <Formik
      enableReinitialize
      initialValues={entity}
      validationSchema={ValidationSchema}
      onSubmit={(values) => {
        save(values);
      }}
    >
      {({
        touched, errors, values, setFieldValue,
      }) => (
        <Form id="TruckForm" autoComplete="off">
          <Row className="border-bottom">
            <div>
              <Label
                for="reference"
                className="pe-0 ps-0"
              >
                {props.t('Reference')}
              </Label>
              <Field
                type="text"
                className={`form-control ${(errors.reference && touched.reference ? 'is-invalid' : '')}`}
                id="reference"
                name="reference"
              />
              <div className="help-block text-muted pt-1">
                {props.t('BOL, Tracking Number, etc.')}
              </div>
              <ErrorMessage
                name="reference"
                component="div"
                className="text-danger"
              />
            </div>

            <Row className="p-3 pe-0">
              <Col sm={4}>
                <div className="form-check form-switch form-switch-md pt-1">
                  <Field
                    type="checkbox"
                    className="form-check-input"
                    id="outbound"
                    name="outbound"
                    checked={values.outbound === 1} // Treat `1` as checked
                    onChange={() => {
                      setFieldValue('outbound', values.outbound === 1 ? 0 : 1);
                    }}
                  />
                  <Label
                    for="outbound"
                    className="form-check-label"
                  >
                    {props.t('Outbound?')}
                  </Label>
                </div>
              </Col>

              <Col sm={8}>
                <SupplierPicker />
              </Col>
            </Row>
          </Row>

          <div className="accordion mt-3" id="accordion">
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingOne">
                <button
                  className={classnames(
                    'accordion-button',
                    'fw-medium',
                    'btn-warning',
                    'btn-soft-warning',
                    'text-dark',
                    { collapsed: !col },
                  )}
                  type="button"
                  onClick={tcol}
                  style={{ cursor: 'pointer' }}
                >
                  {t('Counts & Pricing')}
                </button>
              </h2>

              <Collapse isOpen={col} className="accordion-collapse">
                <div className="accordion-body">
                  <Row>
                    <Col sm={6}>
                      <div className="row p-3">
                        <Label
                          for="cost"
                          className="pe-0 ps-0"
                        >
                          {props.t('Total Price')}
                        </Label>
                        <Field
                          type="number"
                          className={`form-control ${(errors.cost && touched.cost ? 'is-invalid' : '')}`}
                          id="cost"
                          name="cost"
                        />
                        <ErrorMessage
                          name="cost"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={6}>
                      <div className="row p-3">
                        <Label
                          for="unit_count"
                          className="pe-0 ps-0"
                        >
                          {props.t('Unit Count')}
                        </Label>
                        <Field
                          type="number"
                          className={`form-control ${(errors.unit_count && touched.unit_count ? 'is-invalid' : '')}`}
                          id="unit_count"
                          name="unit_count"
                        />
                        <ErrorMessage
                          name="unit_count"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </Col>
                    <Col sm={6}>
                      <div className="row p-3">
                        <Label
                          for="pallet_count"
                          className="pe-0 ps-0"
                        >
                          {props.t('Pallet Count')}
                        </Label>
                        <Field
                          type="number"
                          className={`form-control ${(errors.pallet_count && touched.pallet_count ? 'is-invalid' : '')}`}
                          id="pallet_count"
                          name="pallet_count"
                        />
                        <ErrorMessage
                          name="pallet_count"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row className="border-bottom">
                    <Col sm={6}>
                      <div className="row p-3">
                        <Label
                          for="labor_cost"
                          className="ps-0 pe-0"
                        >
                          {props.t('Labor Cost')}
                        </Label>
                        <Field
                          type="number"
                          className={`form-control ${(errors.labor_cost && touched.labor_cost ? 'is-invalid' : '')}`}
                          id="labor_cost"
                          name="labor_cost"
                        />
                        <ErrorMessage
                          name="labor_cost"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </Col>

                    <Col sm={6}>
                      <div className="row p-3">
                        <Label
                          for="shipping_cost"
                          className="ps-0 pe-0"
                        >
                          {props.t('Shipping Cost')}
                        </Label>
                        <Field
                          type="number"
                          className={`form-control ${(errors.shipping_cost && touched.shipping_cost ? 'is-invalid' : '')}`}
                          id="shipping_cost"
                          name="shipping_cost"
                        />
                        <ErrorMessage
                          name="shipping_cost"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </Collapse>
            </div>
          </div>

          <Row className="border-bottom">
            <Col sm={6}>
              <div className="row p-3">
                <Label
                  for="expected_at"
                  className="ps-0 pe-0"
                >
                  {values.outbound === 0 ? props.t('Expected At') : props.t('Pick-Up Date')}
                </Label>
                <Field
                  type="date"
                  className={`form-control ${(errors.expected_at && touched.expected_at ? 'is-invalid' : '')}`}
                  id="expected_at"
                  name="expected_at"
                />
                <ErrorMessage
                  name="expected_at"
                  component="div"
                  className="invalid-feedback"
                />
              </div>
            </Col>

            <Col sm={6}>
              <div className="row p-3">
                <Label
                  for="origin"
                  className="ps-0 pe-0"
                >
                  {values.outbound === 0 ? props.t('Origin') : props.t('Destination')}
                </Label>
                <Field
                  type="text"
                  className={`form-control ${(errors.origin && touched.origin ? 'is-invalid' : '')}`}
                  id="origin"
                  name="origin"
                />
                <ErrorMessage
                  name="origin"
                  component="div"
                  className="invalid-feedback"
                />
              </div>
            </Col>
          </Row>

          <Row className="p-3">
            <Label
              for="comments"
              className="ps-0 pe-0"
            >
              {props.t('Comments')}
            </Label>
            <Field
              as="textarea"
              className={`form-control ${(errors.comments && touched.comments ? 'is-invalid' : '')}`}
              id="comments"
              name="comments"
            />
          </Row>

          {values.outbound === 1 && (
          <Row>
            <Col sm={6}>
              <div className="row p-3">
                <Label
                  for="staged_lanes"
                  className="ps-0 pe-0"
                >
                  {props.t('Staged Lanes')}
                </Label>
                <Field
                  type="text"
                  className={`form-control ${(errors.staged_lanes && touched.staged_lanes ? 'is-invalid' : '')}`}
                  id="staged_lanes"
                  name="staged_lanes"
                />
                <ErrorMessage
                  name="staged_lanes"
                  component="div"
                  className="invalid-feedback"
                />
              </div>
            </Col>
          </Row>
          )}
        </Form>
      )}
    </Formik>
  );

  return jsx;
}

TruckForm.defaultProps = {
  entity: {
    reference: '',
  },
  onSuccess: () => {},
};

TruckForm.propTypes = {
  actionUrl: PropTypes.string.isRequired,
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  entity: PropTypes.object,
  onSuccess: PropTypes.func,
};

export default connect((state) => ({

}), {})(withTranslation()(TruckForm));
